export const CHECKINS_GUIDE_LINK = 'https://oboard.atlassian.net/wiki/spaces/OBPFJ/pages/2415198209'
export const CHECKINS_TUTORIAL_LINK = 'https://youtu.be/g0xs7IxqXpU'
